import React from 'react';
import Spinner from '~/components/Spinner/Spinner';
import styles from './ManageWordsLoader.module.css';

type ManageWordsLoaderProps = {
  comment?: string;
};

export default function ManageWordsLoader({ comment }: ManageWordsLoaderProps) {
  return (
    <div className={styles.loadingContainer}>
      <Spinner />
      <h3 className={styles.comment}>{comment}</h3>
    </div>
  );
}
